import i18n from 'src/i18n';
import type { SkuDetailData } from 'src/services/api/getSkuDetail';
import type { SkuForecastData } from 'src/services/api/getSkuForecastData';
import { buildForecastStoreKey } from 'src/store/forecastSlice';
import { useBoundStore } from 'src/store/store';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

class ForecastService {
  formatForecastData(
    data: SkuForecastData,
    sku: string,
    scopeId?: string,
  ): SkuForecastData {
    const formatedData = data.map((item) => {
      return {
        ...item,
        month_id: new Intl.DateTimeFormat(i18n.language, {
          month: 'short',
          year: 'numeric',
        }).format(new Date(item.year, item.month - 1)),
      };
    });
    return this.processForecastData(formatedData, sku, scopeId);
  }

  processForecastData(
    data: ForecastDataPoint[],
    sku: string,
    scopeId?: string,
  ): SkuForecastData {
    const setForecastData = useBoundStore.getState().setForecastData;
    const clearForecastData = useBoundStore.getState().clearForecastData;
    const normalizedScopeId = scopeId ?? 'default';

    clearForecastData(sku, normalizedScopeId);
    setForecastData(sku, data, normalizedScopeId);

    return data;
  }

  getStoreKey(sku: string, scopeId?: string): string {
    return buildForecastStoreKey(sku, scopeId ?? 'default');
  }

  formatSkuDetail(data: SkuDetailData): SkuDetailData {
    return {
      ...data,
      product_started_at_date_key: new Date(
        data.product_started_at_date_key,
      ).toLocaleDateString(),
      product_first_stock_entry_at_date_key:
        data.product_first_stock_entry_at_date_key
          ? new Date(
              data.product_first_stock_entry_at_date_key,
            ).toLocaleDateString()
          : '-',
      last_reviewed_date: data.last_reviewed_date
        ? new Date(data.last_reviewed_date).toLocaleDateString()
        : '-',
    } as SkuDetailData;
  }
}

export default new ForecastService();
